import { Button as AntButton } from "antd";
import React from "react";
import { MdKeyboardVoice, MdStop } from "react-icons/md";

const getStatus = (status) => {
  switch (status) {
    case "running":
      return "#ff4d4f";
    case "stop":
      return "#096dd9";
    default:
      return "#096dd9";
  }
};

const Button = (props) => {
  const { color, disabled, status, children } = props;

  return (
    <AntButton
      size={"large"}
      type="primary"
      icon={
        status === "running" ? (
          <MdStop size={20} style={{ marginTop: 4 }} />
        ) : (
          <MdKeyboardVoice size={18} style={{ marginTop: 3 }} />
        )
      }
      style={{
        paddingTop: -5,
        backgroundColor: color
          ? disabled
            ? color.disabled
            : color.active
          : getStatus(status),
        borderColor: color
          ? disabled
            ? color.disabled
            : color.active
          : getStatus(status),
      }}
      disabled={disabled}
      {...props}
    >
      {children}
    </AntButton>
  );
};

export default Button;
